import './tableForMyPackagesPage.css'

import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useMemo, useState } from 'react'
import { Button, Container, Modal, Spinner, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import { useRejectPkgReq } from '../../../api/package-req'
import { useCreatePkgReq } from '../../../api/package-req/mutations/useCreatePkgReq'
import { useUserUnshippedPackages } from '../../../api/user-package/hooks/useUserUnshippedPackage'
import SnackbarModal from '../../../Components/SnackbarModal'
import calcWeight from '../../../helpers/CalculationFunction'
import greeceFlagCircle from '../../../imgs/flags/greece-circle.png'
import ukFlagCircle from '../../../imgs/flags/uk-circle.png'
import usaFlag from '../../../imgs/flags/usa.png'
import world from '../../../imgs/flags/world.png'
import noPackages from '../../../imgs/shopping-bag.jpg'
import { QUERY_KEYS } from '../../../lib/queryKeys'
import { setIsUniteMode } from '../../../store/packageSlice'
import ItemCompForTableInMypackages from './ItemCompForTableInMypackages'

export default function TableForMyPackagesPage() {
  const dispatch = useDispatch()
  const { data: unShippedPackages } = useUserUnshippedPackages()
  const { isUniteMode } = useSelector(state => state.packages)

  const [country, setCountry] = useState('all')
  // const [packagesToShow, setPackagesToShow] = useState([])
  const [selectedPackagesIds, setselectedPackagesIds] = useState([])
  const [uniteWarehouse, setUniteWarehouse] = useState({})
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [showUnitedModal, setshowUnitedModal] = useState(false)
  const [showUniteWarehousesMessage, setshowUniteWarehousesMessage] = useState(false)
  const [isSending, setIsSending] = useState(false)
  const [isMobile, setisMobile] = useState(false)
  const [afterUniteModalTitle, setafterUniteModalTitle] = useState('')
  const [afterUniteModalText, setafterUniteModalText] = useState('')
  const [uniteId, setUniteId] = useState('')

  const [showUniteReqSuccessSnackBar, setShowUniteReqSuccessSnackBar] = useState(false)
  const [showUniteModalSameTrackingNumber, setshowUniteModalSameTrackingNumber] = useState(false)
  const { mutateAsync: createPackageReqMutation } = useCreatePkgReq()
  const { mutateAsync: rejectPackageReqMutation } = useRejectPkgReq()
  const queryClient = useQueryClient()

  useEffect(() => {
    setisMobile(window.matchMedia('only screen and (max-width: 760px)').matches)
    if (JSON.parse(localStorage.getItem('payment-page-package'))) localStorage.removeItem('payment-page-package')

    return () => {
      dispatch(setIsUniteMode(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChangeCheckBox = (e, item) => {
    if (e.target.checked) {
      const warehouse = item['warehouse']
      uniteWarehouse[item['id']] = warehouse
      setUniteWarehouse(uniteWarehouse)
    } else {
      delete uniteWarehouse[item['id']]
      setUniteWarehouse(uniteWarehouse)
    }

    if (e.target.checked) {
      // the checkbox check disappear when rerender, but the id remains in the array.
      if (selectedPackagesIds.findIndex(pId => e.target.value === pId) >= 0) return
      setselectedPackagesIds(prevPackages => [...prevPackages, e.target.value])
    } else {
      const selectedPackagesIdsNew = selectedPackagesIds.filter(ele => {
        return ele != e.target.value
      })
      setselectedPackagesIds(selectedPackagesIdsNew)
    }
  }

  const _uniteWeightCheck = () => {
    const packagesForUnite = []

    selectedPackagesIds.forEach(pId => {
      packagesForUnite.push(unShippedPackages.find(p => p.id === pId))
    })

    let finalWeight = packagesForUnite.reduce((acc, p) => {
      acc += calcWeight(p.width, p.length, p.height, p.weight)
      return acc
    }, 0)

    if (finalWeight >= 20) return true
    else return false
  }

  const _uniteFlammableCheck = () => {
    const packagesForUnite = []

    selectedPackagesIds.forEach(pId => {
      packagesForUnite.push(unShippedPackages.find(p => p.id === pId))
    })

    let isFlammable = null
    let isNormal = null
    for (let p of packagesForUnite) {
      if (p.isFlammable) isFlammable = true
      if (!p.isFlammable) isNormal = true

      if ((isFlammable !== null && isNormal !== null) || (isFlammable && isNormal)) {
        return true
      }
    }
    return false
  }

  const _uniteSameTrackingNumberCheck = () => {
    const packagesForUnite = []

    selectedPackagesIds.forEach(pId => {
      packagesForUnite.push(unShippedPackages.find(p => p.id === pId))
    })

    for (let p of packagesForUnite) {
      if (p.trackingNumberInTurkey !== packagesForUnite[0].trackingNumberInTurkey) {
        return false
      }
    }
    return true
  }

  const submitUniteHandler = async () => {
    if (isSending || selectedPackagesIds.length < 2) return
    if (_uniteWeightCheck()) {
      setafterUniteModalTitle('שגיאה!')
      setafterUniteModalText(`
      החבילה כבדה מדי או גדולה מדי.
      לא ניתן לאחד חבילות שמשקלן הכולל, או משקלן הנפחי, הוא מעל 20 ק"ג
      `)
      handleShow()
      return
    }
    if (_uniteFlammableCheck()) {
      setafterUniteModalTitle('שגיאה!')
      setafterUniteModalText('לא ניתן לאחד חבילת נוזלים עם חבילות רגילות')
      handleShow()
      return
    }

    setIsSending(true)
    try {
      const uniteResult = await createPackageReqMutation({
        reqType: 'uniteRequest',
        unitePackageIds: selectedPackagesIds,
      })

      if (uniteResult.statusCode !== 200) {
        throw new Error(uniteResult.msg)
      }
      const unitedObjId = uniteResult.data.id

      for (const i of selectedPackagesIds) {
        if (isMobile) document.getElementById(`${i}c`).classList.remove('pc-checked')
        queryClient.setQueryData([QUERY_KEYS.USER_PACKAGES], old =>
          old?.map(item => (item.id === i ? { ...item, uniteID: unitedObjId, isForUnite: true } : item))
        )
      }
      setselectedPackagesIds([])
      setshowUnitedModal(false)
      setShowUniteReqSuccessSnackBar(true)
      setUniteWarehouse({})
      setUniteMode()
      setshowUniteModalSameTrackingNumber(false)
      setIsSending(false)
    } catch (error) {
      console.log('submitUniteHandler - error:', error)
      setafterUniteModalTitle('שגיאה!')
      setafterUniteModalText('שגיאה בשרת! אנא נסה שנית או פנה לשירות לקוחות')
      handleShow()
      setshowUniteModalSameTrackingNumber(false)
      setIsSending(false)
    }
  }

  //TODO: there is a function in server that update packages and delete unite obj. need new route
  const submitCancelUniteHandler = async () => {
    if (isSending) return
    setIsSending(true)

    try {
      await rejectPackageReqMutation({
        packageReqId: uniteId,
        rejectReason: 'userCanceled',
      })
      setIsSending(false)
    } catch (error) {
      console.log('Error while trying to cancel unite request', error)
      setafterUniteModalTitle('שגיאה!')
      setafterUniteModalText('שגיאה בשרת! אנא נסה שנית או פנה לשירות לקוחות')
      handleShow()
      setshowUniteModalSameTrackingNumber(false)
      setIsSending(false)
    }
  }

  function allAreEqual(obj) {
    return new Set(Object.values(obj)).size === 1
  }

  const unitePackages = async () => {
    if (allAreEqual(uniteWarehouse)) {
      if (_uniteSameTrackingNumberCheck()) {
        setshowUniteModalSameTrackingNumber(true)
        return
      }
      setshowUnitedModal(true)
    } else {
      setshowUniteWarehousesMessage(true)
    }
  }

  const setUniteMode = async () => {
    if (isUniteMode) {
      //if we get out of unite mode, we need to reset
      if (isMobile) {
        for (const i of selectedPackagesIds) {
          document.getElementById(`${i}c`).classList.remove('pc-checked')
        }
      }
      setselectedPackagesIds([])
      setUniteWarehouse({})
      setCountry('all')
    }

    dispatch(setIsUniteMode(!isUniteMode))
  }

  // const setCountry = (countryFromClick) => {
  //   setCountry(countryFromClick)
  //   filterBycountry(countryFromClick)
  // }

  // const filterBycountry = (country) => {
  //   let pFilteredByCountry = []
  //   switch (country) {
  //     case 'GR':
  //       pFilteredByCountry = unShippedPackages.filter((p) => p.warehouse == 'GR')
  //       break
  //     case 'USA':
  //       pFilteredByCountry = unShippedPackages.filter((p) => p.warehouse == 'USA')
  //       break
  //     case 'all':
  //       pFilteredByCountry = unShippedPackages
  //       break
  //   }
  //   setPackagesToShow(pFilteredByCountry)
  //   console.log(' filterBycountry - pFilteredByCountry:', pFilteredByCountry)
  // }

  const packagesToShow = useMemo(() => {
    let filtered = unShippedPackages?.length > 0 ? [...unShippedPackages] : []
    if (country !== 'all') {
      filtered = filtered.filter(item => item.warehouse === country)
    }
    // Sort packages - packages with isForUnite:true will go to the end
    return filtered.sort((a, b) => {
      if (a.isForUnite === b.isForUnite) return 0
      return a.isForUnite ? 1 : -1
    })
  }, [country, unShippedPackages])

  return (
    <section className='rtlText'>
      <div className={isUniteMode ? 'tablepage-unite-row tablepage-unite-row-active' : 'tablepage-unite-row'}>
        <div className='tablepage-unite-row-text'>
          <span style={{ fontWeight: 'bold' }}>בחר/י את החבילות שברצונך לאחד</span>
          <br />
          <span style={{ fontSize: '14px' }}>
            שים ❤️!
            <br />
            ניתן לאחד חבילות רק מאותה מדינה ולא ניתן לאחד חבילות בתהליך צמצום או החזרה.
          </span>
        </div>
        <Button size='sm' variant='outline-info' onClick={setUniteMode}>
          ביטול
        </Button>

        <Button size='sm' onClick={() => unitePackages()} disabled={selectedPackagesIds.length < 2}>
          אחד
        </Button>
      </div>
      <Container>
        <h4
          style={{
            textAlign: 'center',
            marginTop: '20px',
            fontWeight: 'bolder',
          }}
        >
          החבילות שלי
        </h4>

        {!isUniteMode && (
          <div className='tablepage-country-navbar'>
            <div className={country == 'all' ? 'pcn-item pcn-item-active' : 'pcn-item'} onClick={() => setCountry('all')}>
              <img src={world} alt='all' />
              <div className='pcn-item-title'> הכל</div>
            </div>
            <div className={country == 'USA' ? 'pcn-item pcn-item-active' : 'pcn-item'} onClick={() => setCountry('USA')}>
              <img src={usaFlag} alt='usa' />
              <div className='pcn-item-title'>ארה"ב</div>
            </div>
            <div className={country == 'GR' ? 'pcn-item pcn-item-active' : 'pcn-item'} onClick={() => setCountry('GR')}>
              <img src={greeceFlagCircle} alt='Greece' />
              <div className='pcn-item-title'>יוון</div>
            </div>
            <div className={country == 'UK' ? 'pcn-item pcn-item-active' : 'pcn-item'} onClick={() => setCountry('UK')}>
              <img src={ukFlagCircle} alt='UK' />
              <div className='pcn-item-title'>אנגליה</div>
            </div>
          </div>
        )}
      </Container>

      <div className='items-table-container'>
        {!packagesToShow ? (
          <div className='spinner-cont1'>
            <Spinner animation='border' variant='primary'></Spinner>
          </div>
        ) : (
          <>
            {packagesToShow.length === 0 ? (
              <div className='no-packages'>
                <div>אין חבילות עדיין...</div>
                <img src={noPackages} alt='shopping time' />
                <div>זמן טוב לשופינג!</div>
              </div>
            ) : (
              <>
                {isMobile ? (
                  <div className='package-cards-cont'>
                    {packagesToShow.map((item, i) => {
                      return (
                        <ItemCompForTableInMypackages
                          item={item}
                          onChangeCheckBox={e => onChangeCheckBox(e, item)}
                          key={i}
                          submitCancelUniteHandler={submitCancelUniteHandler}
                          setCountry={setCountry}
                          setUniteMode={setUniteMode}
                          setUniteId={setUniteId}
                        />
                      )
                    })}
                  </div>
                ) : (
                  <Table id='myPackTable' className='tableForPackagePage my-packages-table' style={{ marginTop: '0px' }}>
                    <thead>
                      <tr style={{ color: 'white', fontSize: '16px' }}>
                        <th></th>
                        <th>מחסן</th>
                        <th>שם החנות</th>
                        <th>
                          תאריך הגעת <br /> החבילה למחסננו
                        </th>
                        <th>שווי חבילה</th>
                        <th>פריטים</th>
                        <th>
                          גודל (cm) <br /> משקל
                        </th>
                        <th>מספר מעקב מקומי</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {packagesToShow.map((item, i) => {
                        return (
                          <ItemCompForTableInMypackages
                            item={item}
                            onChangeCheckBox={e => onChangeCheckBox(e, item)}
                            key={i}
                            submitCancelUniteHandler={submitCancelUniteHandler}
                            setCountry={setCountry}
                            setUniteMode={setUniteMode}
                            setUniteId={setUniteId}
                          />
                        )
                      })}
                    </tbody>
                  </Table>
                )}
              </>
            )}
          </>
        )}

        {/* {draftPackages?.length > 0 && (
          <>
            <Row>
              <Col>
                <h4
                  style={{
                    color: '#fcde00',
                    textAlign: 'center',
                    marginTop: '5%',
                    fontWeight: 'bolder',
                    marginBottom: '1rem',
                  }}
                >
                  חבילות מפוצלות
                </h4>
                <div style={{ textAlign: 'center', margin: '15px 0' }}>
                  חבילות מפוצלות הן חבילות שזיהינו שהחנות פיצלה הזמנה אחת לכמה משלוחים. החבילה תתעדכן כחבילה רגילה ברגע שכל הפריטים יגיעו למחסן.
                </div>
              </Col>
            </Row>

            <Container className="containerForTable">
              <DraftPackagesTable packages={draftPackages} isMobile={isMobile} />
            </Container>
          </>
        )} */}
      </div>

      <Modal show={show} onHide={handleClose} style={{ direction: 'rtl' }}>
        <Modal.Header style={{ textAlign: 'center' }}>
          <div style={{ width: '100%' }}>
            <Modal.Title>{afterUniteModalTitle}</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>{afterUniteModalText}</Modal.Body>
        <Modal.Footer>
          <Button variant='danger' onClick={handleClose}>
            סגור
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showUnitedModal} onHide={() => setshowUnitedModal(false)} style={{ textAlign: 'center' }} centered={true}>
        <Modal.Header>
          <div style={{ width: '100%' }}>
            <Modal.Title style={{ direction: 'rtl' }}>איחוד חבילות</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <p style={{ direction: 'rtl' }}>
            עלות האיחוד הינה 1.5$ לכל חבילה מתאחדת.
            <br />
            <br />
            שים לב! ❤️
            <br />
            ברגע שאיחדתם חבילות, השווי המוצהר הוא על <span style={{ fontWeight: 'bold' }}>סך כל </span> המוצרים בחבילה המאוחדת.
            <br />
            במידה ואחרי האיחוד שווי החבילה יהיה מעל ל-75$, כנראה יהיה זול יותר לשלוח את החבילות בנפרד.
          </p>
          <div style={{ fontSize: '18px', fontWeight: 'bold' }}>סה"כ לתשלום: {selectedPackagesIds.length * 1.5 + '$'}</div>
        </Modal.Body>
        <Modal.Footer style={{ direction: 'rtl', justifyContent: 'center' }}>
          {!isSending ? (
            <>
              <Button variant='danger' onClick={submitUniteHandler}>
                אישור
              </Button>
              <Button variant='outline-info' onClick={() => setshowUnitedModal(false)}>
                ביטול
              </Button>
            </>
          ) : (
            <Spinner animation='border' variant='primary'></Spinner>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUniteModalSameTrackingNumber}
        onHide={() => setshowUniteModalSameTrackingNumber(false)}
        style={{ textAlign: 'center' }}
        centered={true}
      >
        <Modal.Header>
          <div style={{ width: '100%' }}>
            <Modal.Title style={{ direction: 'rtl' }}>איחוד חבילות חינם</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <p style={{ direction: 'rtl' }}>
            לקוח יקר,
            <br />
            חבילות מפוצלות מאוחדות ללא תשלום נוסף:
            <br />
            <br />
            אם מספר ההזמנה זהה בכל החבילות המתאחדות -
            <br />
            לא תחוייבו בדמי איחוד באופן אוטומטי!
          </p>
        </Modal.Body>
        <Modal.Footer style={{ direction: 'rtl', justifyContent: 'center' }}>
          {!isSending ? (
            <>
              <Button variant='danger' onClick={submitUniteHandler}>
                אישור
              </Button>
              <Button variant='outline-info' onClick={() => setshowUniteModalSameTrackingNumber(false)}>
                ביטול
              </Button>
            </>
          ) : (
            <Spinner animation='border' variant='primary'></Spinner>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUniteWarehousesMessage}
        onHide={() => setshowUniteWarehousesMessage(false)}
        style={{ textAlign: 'center' }}
        centered={true}
      >
        <Modal.Body>
          <div style={{ fontSize: '18px' }}>לא ניתן לאחד חבילות ממדינות שונות</div>
        </Modal.Body>
        <Modal.Footer style={{ direction: 'rtl', justifyContent: 'center' }}>
          <Button variant='outline-info' onClick={() => setshowUniteWarehousesMessage(false)}>
            אישור
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Unite Request success Modal */}
      <SnackbarModal
        showModal={showUniteReqSuccessSnackBar}
        setShowModal={setShowUniteReqSuccessSnackBar}
        iconType='approve'
        title='קיבלנו את בקשתך לאיחוד!'
        description='מוקד שירות הלקוחות יצור איתך קשר עד 2 ימי עסקים'
      />
    </section>
  )
}
